/* 回到顶部 */
var timer = null // 存放定时器

function goTop() {
  timer = setInterval(function () { // 设置定时器
    // 获取滚动条距离顶部的高度
    var osTop = document.documentElement.scrollTop || document.body.scrollTop
    var ispeed = osTop / 5
    document.documentElement.scrollTop = document.body.scrollTop = osTop - ispeed
    // isTop = true;
    if (osTop === 0) {
      clearInterval(timer)
    }
  }, 30)
};

export {
  goTop
}



// WEBPACK FOOTER //
// ./src/components/goTop/js/goTop.js